// Provincias y ciudades de Argentina con coordenadas
// Fuente: datos geográficos de referencia nacional

export interface Ciudad {
  nombre: string;
  coords: string; // "lat,lon"
}

export interface Provincia {
  nombre: string;
  ciudades: Ciudad[];
}

export const PROVINCIAS: Provincia[] = [
  {
    nombre: 'Buenos Aires',
    ciudades: [
      { nombre: 'La Plata', coords: '-34.92,-57.95' },
      { nombre: 'Mar del Plata', coords: '-38.00,-57.55' },
      { nombre: 'Bahía Blanca', coords: '-38.72,-62.27' },
      { nombre: 'Tandil', coords: '-37.32,-59.15' },
      { nombre: 'San Nicolás', coords: '-33.33,-60.22' },
      { nombre: 'Zárate', coords: '-34.10,-59.03' },
      { nombre: 'Pergamino', coords: '-33.90,-60.57' },
      { nombre: 'Junín', coords: '-34.59,-60.95' },
      { nombre: 'Olavarría', coords: '-36.89,-60.33' },
      { nombre: 'Luján', coords: '-34.57,-59.11' },
    ],
  },
  {
    nombre: 'CABA',
    ciudades: [
      { nombre: 'Buenos Aires', coords: '-34.60,-58.38' },
    ],
  },
  {
    nombre: 'Catamarca',
    ciudades: [
      { nombre: 'San Fernando del Valle de Catamarca', coords: '-28.47,-65.78' },
    ],
  },
  {
    nombre: 'Chaco',
    ciudades: [
      { nombre: 'Resistencia', coords: '-27.45,-58.98' },
      { nombre: 'Presidencia Roque Sáenz Peña', coords: '-26.78,-60.44' },
    ],
  },
  {
    nombre: 'Chubut',
    ciudades: [
      { nombre: 'Rawson', coords: '-43.30,-65.10' },
      { nombre: 'Comodoro Rivadavia', coords: '-45.87,-67.50' },
      { nombre: 'Puerto Madryn', coords: '-42.77,-65.05' },
      { nombre: 'Trelew', coords: '-43.25,-65.31' },
    ],
  },
  {
    nombre: 'Córdoba',
    ciudades: [
      { nombre: 'Córdoba', coords: '-31.42,-64.19' },
      { nombre: 'Villa María', coords: '-32.41,-63.25' },
      { nombre: 'Río Cuarto', coords: '-33.13,-64.35' },
      { nombre: 'Carlos Paz', coords: '-31.40,-64.52' },
      { nombre: 'San Francisco', coords: '-31.43,-62.09' },
    ],
  },
  {
    nombre: 'Corrientes',
    ciudades: [
      { nombre: 'Corrientes', coords: '-27.47,-58.83' },
      { nombre: 'Goya', coords: '-29.14,-59.26' },
    ],
  },
  {
    nombre: 'Entre Ríos',
    ciudades: [
      { nombre: 'Paraná', coords: '-31.73,-60.53' },
      { nombre: 'Concordia', coords: '-31.40,-58.03' },
      { nombre: 'Gualeguaychú', coords: '-33.01,-58.52' },
      { nombre: 'Concepción del Uruguay', coords: '-32.48,-58.24' },
    ],
  },
  {
    nombre: 'Formosa',
    ciudades: [
      { nombre: 'Formosa', coords: '-26.18,-58.18' },
    ],
  },
  {
    nombre: 'Jujuy',
    ciudades: [
      { nombre: 'San Salvador de Jujuy', coords: '-24.19,-65.30' },
      { nombre: 'Palpalá', coords: '-24.26,-65.21' },
    ],
  },
  {
    nombre: 'La Pampa',
    ciudades: [
      { nombre: 'Santa Rosa', coords: '-36.62,-64.28' },
    ],
  },
  {
    nombre: 'La Rioja',
    ciudades: [
      { nombre: 'La Rioja', coords: '-29.41,-66.86' },
    ],
  },
  {
    nombre: 'Mendoza',
    ciudades: [
      { nombre: 'Mendoza', coords: '-32.89,-68.84' },
      { nombre: 'San Rafael', coords: '-34.61,-68.33' },
      { nombre: 'Godoy Cruz', coords: '-32.92,-68.84' },
    ],
  },
  {
    nombre: 'Misiones',
    ciudades: [
      { nombre: 'Posadas', coords: '-27.37,-55.90' },
      { nombre: 'Puerto Iguazú', coords: '-25.60,-54.57' },
      { nombre: 'Oberá', coords: '-27.49,-55.12' },
    ],
  },
  {
    nombre: 'Neuquén',
    ciudades: [
      { nombre: 'Neuquén', coords: '-38.95,-68.06' },
      { nombre: 'San Martín de los Andes', coords: '-40.16,-71.35' },
    ],
  },
  {
    nombre: 'Río Negro',
    ciudades: [
      { nombre: 'San Carlos de Bariloche', coords: '-41.13,-71.31' },
      { nombre: 'Viedma', coords: '-40.81,-62.99' },
      { nombre: 'General Roca', coords: '-39.03,-67.58' },
    ],
  },
  {
    nombre: 'Salta',
    ciudades: [
      { nombre: 'Salta', coords: '-24.78,-65.41' },
      { nombre: 'San Ramón de la Nueva Orán', coords: '-23.14,-64.33' },
    ],
  },
  {
    nombre: 'San Juan',
    ciudades: [
      { nombre: 'San Juan', coords: '-31.54,-68.52' },
      { nombre: 'Rivadavia', coords: '-31.53,-68.56' },
    ],
  },
  {
    nombre: 'San Luis',
    ciudades: [
      { nombre: 'San Luis', coords: '-33.30,-66.34' },
      { nombre: 'Villa Mercedes', coords: '-33.67,-65.46' },
    ],
  },
  {
    nombre: 'Santa Cruz',
    ciudades: [
      { nombre: 'Río Gallegos', coords: '-51.62,-69.22' },
      { nombre: 'Caleta Olivia', coords: '-46.44,-67.53' },
      { nombre: 'El Calafate', coords: '-50.34,-72.28' },
    ],
  },
  {
    nombre: 'Santa Fe',
    ciudades: [
      { nombre: 'Rosario', coords: '-32.95,-60.64' },
      { nombre: 'Santa Fe', coords: '-31.63,-60.70' },
      { nombre: 'Rafaela', coords: '-31.26,-61.49' },
      { nombre: 'Venado Tuerto', coords: '-33.75,-61.97' },
    ],
  },
  {
    nombre: 'Santiago del Estero',
    ciudades: [
      { nombre: 'Santiago del Estero', coords: '-27.79,-64.26' },
      { nombre: 'La Banda', coords: '-27.73,-64.24' },
    ],
  },
  {
    nombre: 'Tierra del Fuego',
    ciudades: [
      { nombre: 'Ushuaia', coords: '-54.80,-68.30' },
      { nombre: 'Río Grande', coords: '-53.79,-67.72' },
    ],
  },
  {
    nombre: 'Tucumán',
    ciudades: [
      { nombre: 'San Miguel de Tucumán', coords: '-26.82,-65.22' },
      { nombre: 'Tafí Viejo', coords: '-26.73,-65.27' },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/app/admin/modal-equipo/ubicaciones-argentina.ts